// 土耳其语
const tr = {
  common: {
    notSupport: 'Tarayıcınız tam ekran modunu desteklemiyor',
    loadFail: 'Tema yüklemesi başarısız oldu',
    noPermission: 'Üzgünüz, bu sayfaya erişim izniniz yok',
    backHome: 'Ana sayfaya dön',
    noExit: 'Erişmeye çalıştığınız sayfa mevcut değil',
    serverError: 'Üzgünüz, sunucu bir hatayla karşılaştı',
    slide: 'Sağa kaydırın',
    veryHigh: 'Çok Yüksek',
    high: 'Yüksek',
    target: 'Hedef',
    urgentLow: 'Çok Düşük',
    agpNoData: 'AGP raporunun oluşturulması için en az 5 günlük veri gerekir',
    noDataStr: 'Veri Yok',
    setting: 'Ayar',
    personInfo: 'Temel Bilgiler',
    updatePwd: 'Şifre Değiştir',
    upHead: 'Resim Yükleme',
    inRange: 'Menzil İçinde',
    normal: 'Normal',
    low: 'Düşük',
    previous: 'Önceki',
    next: 'Sonraki',
    search: 'Arama',
    reset: 'Sıfırla',
    cancel: 'İptal',
    ok: 'Tamam.',
    confirm: 'Onaylayın',
    save: 'Kaydet',
    submit: 'Gönder',
    successful: 'Başarılı',
    pleaseEnter: 'Lütfen girin',
    pleaseSelect: 'Lütfen seçiniz',
    success: 'Başarı',
    confirmLogout: 'Oturumu kapatmak istediğinizden emin misiniz?',
    updateSuccessed: 'Güncelleme başarılı',
    warning: 'Uyarı',
    date: 'Tarih',
    start: 'Başlangıç',
    end: 'Bitiş',
    sevenDays: '7 Gün',
    fourteenDays: '14 Gün',
    thirtyDays: '30 Gün',
    signOut: 'Çıkış Yapın',
    personalInformation: 'Kişisel Bilgiler',
    email: 'E-posta',
    name: 'İsim',
    mobile: 'Mobil',
    dateOfBirth: 'D.O.B.',
    gender: 'Cinsiyet',
    diabeteType: 'Diyabet Türü',
    dateOfDignose: 'Teşhis yılı',
    remarks: 'Açıklamalar',
    optionMale: 'Erkek',
    optionFemale: 'Kadın',
    optionUnknow: 'Belirtmemeyi Tercih Ediyorum',
    noDiabetes: 'Diyabet Yok',
    diabeteTypeI: 'Tip I',
    diabeteTypeII: 'Tip II',
    diabeteSpecial: 'Özel',
    diabeteGestational: 'Gestasyonel Diyabet',
    diabeteOthers: 'Diğerleri',
    ruleMsgEmail: 'Lütfen e-posta girin',
    ruleMsgName: 'Lütfen isim giriniz',
    ruleMsgMobile: 'Lütfen cep telefonunuzu girin',
    ruleMsgBirthday: 'Lütfen doğum gününü seçin',
    ruleMsgSex: 'Lütfen cinsiyet seçiniz',
    ruleMsgDiabeteType: 'Lütfen diyabet tipini seçiniz',
    ruleMsgDateOfDignose: 'Lütfen teşhis yılını seçiniz',
    ruleMsgRemarks: 'Lütfen açıklamaları girin',
    ruleMsgCorrectMobile: 'Lütfen doğru cep telefonunu girin',
    oldPassword: 'Eski Şifre',
    newPassword: 'Yeni Şifre',
    confirmPassword: 'Şifreyi Onayla',
    ruleMsgOldPassword: 'Lütfen eski şifreyi girin',
    ruleMsgNewPassword: 'Lütfen yeni şifre girin',
    ruleMsgConfirmPassword: 'Lütfen şifreyi onaylayın',
    passwordInconsistent: 'İki parola girişi tutarsızdır',
    passwordModifySuccessed: 'Şifreniz sıfırlandı, lütfen tekrar giriş yapın!',
    monday: 'Paz',
    tuesday: 'Salı',
    wednesday: 'Çar',
    thursday: 'Per',
    friday: 'Cuma',
    saturday: 'Cum',
    sunday: 'Pazar',
    sn: 'SN',
    startDate: 'Başlangıç Tarihi',
    days: 'günler',
    pdfDate: 'Hedef',
    close: 'yakın',
    inputTip: 'Lütfen aramak için anahtar kelimeleri girin',
    polarization: 'Cihaz Başlatılıyor',
    hour: 'h',
    minutes: 'min',
    seconds: 's',
    reportDownLoadTip: 'Raporunuz 5 gündür oluşturulmadı.',
    age: 'yaş',
    goal: 'Hedef',
    expired: 'sensör Süresi doldu',
    lastTime: 'Son Yenilenme Zamanı',
    timeZone: 'Saat dilimi'
  },
  route: {
    login: 'Giriş',
    forget: 'Şifremi Unuttum',
    home: 'Ev',
    glucoseReport: 'Glikoz Raporu',
    sessionReport: 'Oturum Raporu',
    eventList: 'Etkinlik Listesi',
    followerList: 'Takipçi Listesi',
    followerListQ: 'Gözlemci Talebi',
    settings: 'Ayarlar',
    profile: 'Profil'
  },
  login: {
    rememberMe: 'Hatırla beni',
    forgetPassword: 'Şifreyi unut',
    agree: "Giriş yapmak FurCarer'ı kabul etmek anlamına gelir",
    privacyPolicy: 'Gizlilik Politikası',
    CGMUser: 'CGM Kullanıcısı',
    follower: 'Takipçi',
    ruleMsgPassword: 'Lütfen şifreyi girin',
    login: 'Giriş',
    phonePlacehold: 'Lütfen telefon numaranızı girin',
    codePlacehold: 'Lütfen doğrulama kodunu girin',
    codePlaceholdInput: 'Lütfen t...',
    phoneTip: 'Telefon ile',
    emialTip: 'E-posta ile',
    codeTip: 'Doğrulama kodunu alın',
    reGetTip: 'Yeniden satın alma'
  },
  layout: {
    collapseUp: 'Menüyü Gizle',
    collapseDown: 'Menüyü Genişlet',
    refresh: 'Yenile',
    backHome: 'Ev',
    helpCenter: 'Yardım Merkezi',
    fullScreen: 'Tam Ekran'
  },
  forget: {
    ruleMsgCode: 'Lütfen kodu girin',
    sendCode: 'Kod Gönder',
    tipsMsgSendSuccess: 'Doğrulama kodu başarıyla gönderildi!',
    tipsMsgModifySuccess: 'Parola değişikliği başarılı'
  },
  home: {
    title: 'FurCarer Portal',
    todaysGlucose: 'Bugün Glikoz',
    todaysOverview: 'Günümüze Genel Bakış',
    maxGlucose: 'Maks. Glikoz',
    minGlucose: 'Min. Glikoz',
    avgGlucose: 'Avg. Glikoz',
    maxmumVariation: 'Maksimum Varyasyon',
    glucose: 'Glikoz',
    tir: 'TIR',
    latestGlucose: 'Son Glikoz',
    todayPercentage: "Bugünün %'si farklı aralıkta",
    fourHour: '4 Saat',
    eightHour: '8 Saat',
    twelveHour: '12 Saat',
    twentyFourHour: '24 Saat',
    glucoseOnly: 'Sadece Glikoz',
    sessionOverview: 'Oturuma Genel Bakış',
    glocuseMetrics: 'Glikoz Ölçümleri',
    agp: 'AGP',
    dailyGlucose: 'Günlük Glikoz',
    sessionGlucose: 'Oturum Glikoz',
    standTir: 'TIR standardı',
    customTir: 'Özelleştirilmiş TIR',
    cancleGz: 'Takibi bırak',
    cancleText: 'Mevcut kullanıcıyı takip etmeyi bırakmak mı istiyorsunuz?',
    helpCenterTip: 'Fonksiyon henüz açık değil'
  },
  glucoseReport: {
    statics: 'Statik',
    sixHour: '6 Saatlik TIR',
    avgGlucose: 'Ortalama Glikoz',
    maxGlucose: 'Maksimum Glikoz',
    minGlucose: 'Min Glikoz',
    cv: 'CV',
    high: 'Yüksek Sayılar',
    low: 'Düşük Sayılar',
    normal: 'Normal Sayılar',
    tir: 'TIR',
    estimatedA1c: 'Tahmini A1c',
    min: 'Min',
    avg: 'Avg',
    max: 'Maksimum',
    maxVariation: 'Maksimum Varyasyon'
  },
  glucoseProfile: {
    avg: 'Avg',
    sd: 'SD',
    cv: 'CV'
  },
  eventList: {
    all: 'Tümü',
    bg: 'BG',
    meal: 'Yemek',
    sport: 'Spor',
    insulin: 'İnsülin',
    alert: 'Uyarı',
    eventType: 'Etkinlik Türü',
    description: 'Açıklama',
    note: 'Not',
    highAlert: 'uyarı uyarısı',
    calibration: 'Kalibrasyon',
    meds: 'Bal',
    time: 'Zaman',
    detail: 'Detay',
    weigt: 'Ağırlık'
  },
  followerList: {
    title: 'Kullanıcıların İzlenmesi',
    tabTitle: 'Takipçi Yönetimi',
    refreshText:
      'Otomatik yenileme (kullanıcı listesi her 30 saniyede bir otomatik olarak yenilenir)',
    addText: 'Ekle',
    dataText: 'Elde edilen veriler',
    timeText: 'dakika',
    hourText: 'saatler',
    agoText: ' önce',
    tableEmail: 'Hesap numarasını girin',
    searchPlacehold: 'Arama yapmak için lütfen hesap numaranızı girin',
    pending: 'Beklemede',
    approved: 'Onaylandı',
    rejected: 'Reddedildi',
    addFollower: 'Takipçi Ekle',
    editFollower: 'Takipçiyi Düzenle',
    tableName: 'İsim',
    tableAddTime: 'Zaman Ekle',
    tableStatus: 'Durum',
    tableApproved: 'Onaylandı',
    tableReject: 'Reddet',
    tableStartSharing: 'Paylaşmaya Başlayın',
    tableStopSharing: 'Paylaşmayı Durdurun',
    op: 'Çalıştırmak',
    sharing: 'Paylaşım',
    notSharing: 'Paylaşmıyor',
    tableRemove: 'Kaldır',
    note: 'Not',
    message: 'Mesaj',
    ruleMsgEmailEmpty: 'Aramak için lütfen e-posta girin',
    ruleMsgNote: 'Lütfen not girin',
    ruleMsgMessage: 'Lütfen mesaj bırakın',
    ruleMsgEmailCorrect: 'Lütfen doğru e-postayı girin',
    formAcknowledge:
      'Takipçi eklemenin bu kullanıcının verilerimi görmesine izin vereceğini kabul ediyorum',
    sendFollowRequest: 'Takip İsteği Gönder',
    setNote: 'Set Notu',
    tipsAcknowledge:
      'Lütfen kutuyu işaretleyin, takipçi eklemenin bu kullanıcının verilerimi görmesine izin vereceğini kabul ediyorsunuz',
    stopSharing: 'Paylaşmayı Durdurun',
    startSharing: 'Paylaşmaya Başlayın',
    removeUser: 'Kullanıcı Kaldır',
    confirmStopSharing:
      'Bu kullanıcıyla glikoz paylaşımını durdurmak istediğinizden emin misiniz?',
    confirmStartSharing:
      'Bu kullanıcıyla glikoz paylaşmaya başlamak istediğinizden emin misiniz?',
    confirmRemove:
      'Bu kullanıcıyı listeden çıkarmak istediğinizden emin misiniz?',
    approvedFollower: 'Onaylı Takipçi',
    rejectFollower: 'Takipçiyi Reddet',
    confirmApproved: 'Bu takipçi isteğini onayladığınızdan emin misiniz?',
    confirmReject: 'Bu takipçi talebini reddettiğinizden emin misiniz?',
    addTime: 'Zaman Ekle',
    check: 'Kontrol et',
    remove: 'Kaldırmak',
    removeUserTitle:
      'Bu kullanıcıyı listeden çıkarmak istediğinizden emin misiniz?'
  },
  settings: {
    title: 'Glikoz Seviyesi ayarları',
    unitSet: 'Birim Ayarı',
    targetSet: 'Özelleştirilmiş TIR Ayarı',
    alertSet: 'Uyarı Ayarı',
    highAlert: 'Yüksek Alarm',
    lowAlert: 'Düşük Uyarı',
    urgentLow: 'Çok Düşük',
    urgentHigh: 'Acil Yüksek',
    target: 'Hedef'
  },
  pdf: {
    dailyStatistics: 'Günlük İstatistikler',
    title: 'AGP Raporu: Sürekli Glikoz İzleme',
    page: 'Sayfa',
    generated: 'Tarafından oluşturuldu',
    lage: 'LAGE',
    mage: 'MAGE',
    modd: 'MODD',
    range: 'Aralıktaki Zaman',
    timeInRange: 'Menzil İçinde Zaman (TIR)',
    agpTitle: 'Ambulatuvar Glikoz Profili （AGP）',
    agpSubTitle:
      'AGP, rapor dönemindeki glikoz değerlerinin bir özetidir ve medyan (%50) ve diğer yüzdelik dilimler tek bir günde gerçekleşmiş gibi gösterilir',
    dailyTitle: 'Günlük Glikoz Profili',
    dailySubTitle:
      'Her bir günlük profil gece yarısından gece yarısına kadar olan dönemi temsil eder.',
    device: 'Cihaz',
    tDevice: 'Terminal Cihazı',
    print: 'Yazdır',
    model: 'Model',
    deviceSn: 'Cihaz SN',
    effectiveData: 'Etkili Veriler',
    days: 'Günler',
    appVer: 'Uygulama Sürümü',
    smartPhoneModel: 'Akıllı Telefon Modeli',
    osVersion: 'İşletim Sistemi Sürümü',
    appSetting: 'Uygulama Ayarı',
    GoalsforType1andType2Diabetes: 'Tip 1 ve Tip 2 Diyabet için Hedefler',
    Each1timeinrange15minutes: 'Aralıktaki her %1 zaman =~15 dakika',
    note: 'Not: % birimi DCCT standardına, mmol/mol birimi ise IFCC standardına uygundur.',
    DOB: 'DOB',
    SN: 'SN'
  },
  field: {
    timeCgmActive: 'CGM Aktif Olduğu Zaman',
    gmi: 'GMI',
    gri: 'GRI',
    eHbA1c: 'eHbA1c',
    avgPerDay: 'Avg. Gün başına kalibrasyon',
    glucoseAbility: 'Glikoz Değişkenliği',
    lage: 'Lage',
    mage: 'Mage',
    tar: 'TAR',
    tbr: 'TBR',
    calibrations: 'Kalibrasyon süreleri'
  },
  agp: {
    agpTitle: 'Ambulatuvar Glikoz Profili（AGP）',
    centerLine: 'Medyan',
    areaLine: 'Aralık',
    target: 'Hedef aralık'
  },
  basic: {
    customTir: 'Özel TIR',
    bloodTip: 'Glikoz hatırlatma ayarları',
    bloodUnit: 'Glikoz Ünitesi',
    highTip: 'Yüksek Glikoz Uyarısı',
    lowTip: 'Düşük Glikoz Uyarısı',
    unitText: 'Ülke bölgesine göre otomatik olarak ayarlanır',
    selectTip:
      'İlgili tarihi seçmek veya seçimini kaldırmak için simgeye tıklayın',
    selectAll: 'Tümünü Seçin'
  },
  report: {
    threeMonth: 'Son 3 ay',
    sixMonth: 'Yaklaşık 6 ay',
    yearText: 'Geçen yıl',
    showAll: 'Tümünü Göster',
    all: 'Tümü',
    selectDate: 'Tarih aralığı seçin',
    to: 'için',
    startDt: 'Başlangıç Tarihi',
    endDt: 'Bitiş Tarihi',
    betaTest: 'Beta Testi',
    bloodData: 'Glikoz verileri',
    userCount: 'Kullanıcı Hesabı'
  },
  petDetail: {
    variety: 'Cins',
    type: 'İnsülin tipi',
    freq: 'İnsülin Frekansı.',
    lente: 'Bant',
    insulin: 'İnsülin Glargine',
    pzi: 'PHP',
    nph: 'NPH',
    detemir: 'Detemir'
  },
  pdfReport: {
    title: 'AGP Raporu',
    snNumber: 'SN',
    page: 'Sayfa',
    createTime: 'Tarafından oluşturuldu',
    petInfo: 'Evcil Hayvan Bilgileri',
    petName: 'Evcil Hayvan Adı',
    birthday: 'D.O.B.',
    freq: 'İnsülin Frekansı.',
    petType: 'Evcil Hayvan Türü',
    age: 'Yaş',
    registerType: 'Şırınga Tipi',
    basicBloodData: 'Glikoz Ölçümleri',
    dbText: 'Aralıktaki zaman（TIR）',
    target: 'Tip 1 ve Tip 2 Diyabet için Hedefler',
    recordTime: 'Kayıt süresi',
    tag: 'etiket',
    event: 'Etkinlik',
    eventDetail: 'Etkinlik Detayları',
    mulityText: 'Çok günlük glikoz trend grafiği',
    mulitySubText:
      'Çok günlük glikoz profilleri bir cihaz turunun zaman aralığını temsil eder',
    avageBlood: 'Ortalama Glikoz',
    bloodText: 'MODD',
    highTip: 'Yüksek Glikoz Uyarısı',
    lowTip: 'Düşük Glikoz Uyarısı',
    cat: 'Kedi',
    dog: 'Köpek',
    country: 'Ülke',
    insulinDose: 'İnsülin Dozu',
    weightUnit: 'kg'
  },
  eventDetail: {
    Empty: 'Açlık',
    After_Breakfast: 'Kahvaltıdan Sonra',
    Before_Lunch: 'Öğle Yemeğinden Önce',
    Breakfast: 'Kahvaltı',
    Lunch: 'Öğle Yemeği',
    Dinner: 'Akşam Yemeği',
    Before_Sleep: 'Uykudan Önce',
    Extra: 'Ekstra',
    Short_acting: 'Kısa etkili',
    Pre_mixed: 'Önceden karıştırılmış',
    Long_acting: 'Uzun etkili',
    Middle_acting: 'Orta oyunculuk',
    hour: 'saat',
    minutes: 'mins'
  }
};
export default tr;
